import { Injectable, inject } from '@angular/core';
import { LernformKey } from '../../../../model/aggregations';
import { orderedDigitaleLernformen } from '../../../../model/lernformen';
import { LernformFacettenService } from './lernformfacetten.service';
import { LernformUrlService } from './lernformurl.service';

@Injectable({ providedIn: 'root' })
export class DigitaleLernformService extends LernformFacettenService {
  static identifier: LernformKey = LernformKey.Digital;

  constructor() {
    const lernformUrlService = inject(LernformUrlService);

    super(lernformUrlService, DigitaleLernformService.identifier, orderedDigitaleLernformen);
  }
}
